import React from 'react';
import { Skeleton } from './ui/skeleton';

interface LoadingProps {
  text?: string;
  inline?: boolean;
  overlay?: boolean;
  variant?: 'spinner' | 'skeleton';
  skeletonCount?: number;
}

const Loading: React.FC<LoadingProps> = ({
  text = 'Loading...',
  inline = false,
  overlay = false,
  variant = 'spinner',
  skeletonCount = 3
}) => {
  // Spinner component
  const Spinner = () => (
    <div
      className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
      role="status"
      aria-label="Loading"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );

  if (overlay) {
    return (
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] animate-in fade-in duration-200 motion-reduce:animate-none">
        <div className="flex flex-col items-center gap-4 bg-white rounded-none p-8 shadow-neo border-2 border-[#161E54]">
          <Spinner />
          <div className="text-gray-700 font-medium">{text}</div>
        </div>
      </div>
    );
  }

  if (inline) {
    return (
      <div className="flex items-center gap-3">
        <Spinner />
        <span className="text-gray-700 font-medium">{text}</span>
      </div>
    );
  }

  if (variant === 'skeleton') {
    return (
      <div className="space-y-4">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="text-center py-10">
      <Spinner />
      <div className="text-gray-700 font-medium mt-4">{text}</div>
    </div>
  );
};

export default Loading;
